module.exports = __webpack_public_path__ + "img/section-equipos.7160461f.jpeg";